// extracted by mini-css-extract-plugin
export default {"currencyContainer":"CurrencyInput__currencyContainer--ieDJZ"};